export default {
  activeIncidents: [],
  resolvedIncidents: [],
  endpoints: [],
  loading: false,
  error: null,
};
